import { render, staticRenderFns } from "./newresult.vue?vue&type=template&id=2bd8137c&scoped=true&"
import script from "./newresult.vue?vue&type=script&lang=js&"
export * from "./newresult.vue?vue&type=script&lang=js&"
import style0 from "./newresult.vue?vue&type=style&index=0&id=2bd8137c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd8137c",
  null
  
)

export default component.exports